import { StandardEvents } from '@shopify/events';

/**
 * Parité maquette (choix de taille) : le variant-picker natif affiche la valeur d'option complète
 * ("S = 27 cm"), la maquette veut un libellé court sur une ligne ("S"). On ne renomme jamais les
 * valeurs d'option en back-office (elles restent la source de vérité, lue par aria-label sur
 * l'input natif) : ce script ne touche que le texte visuel du bouton, selon la même règle de
 * dérivation que `snippets/product-card-brand.liquid` (part avant « = », espaces retirés). Rejoue
 * au chargement, après chaque rendu de section en éditeur et après chaque changement de variante
 * (le morph remplace le markup par le HTML frais du serveur, texte complet) : idempotent, jamais
 * de double troncature.
 */
function shortenSizeLabels(root) {
  const nodes = root.querySelectorAll('.product-details .variant-option__button-label__text');
  for (const node of nodes) {
    const full = node.textContent.trim();
    if (!full.includes(' = ')) continue;
    const short = full.split(' = ')[0].trim();
    if (node.textContent.trim() !== short) node.textContent = short;
  }
}

shortenSizeLabels(document);
document.addEventListener('shopify:section:load', (event) => shortenSizeLabels(event.target));
document.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise?.then(() => shortenSizeLabels(document)).catch(() => {});
});
